import { UppClientOptions } from './interfaces'
import { UppClient } from './upp-client'
import { CONFIG_VERSION } from '../config'

/**
 * Initialize UPP. Any available content items will be displayed. When no more content is available, the Promise
 * returned by this function will resolve.
 * The Promise will reject if there are any runtime errors.
 * @param options
 */
async function init(options: UppClientOptions): Promise<void> {
  const client = new UppClient()
  return client.init(options)
}

export default {
  init,
  version: CONFIG_VERSION
}
